import { Loader } from 'lucide-react';

const ButtonLoader = () => {
    return (
        <div className='flex items-center justify-center'>
            <Loader className='w-5 h-5 animate-spin text-white' />
        </div>
    );
};

export default ButtonLoader;
